/* HADARA · PREDICTIVE SEARCH HELPERS
   The drawer ships its own logic in snippets/search-drawer.liquid. */
window.HadaraSearch = {
  query: function (q, limit) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,page&resources[limit]=' + (limit || 6),
      { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
};
